import { render, staticRenderFns } from "./defaultPriceTotal.vue?vue&type=template&id=9138dcf6&"
import script from "./defaultPriceTotal.vue?vue&type=script&lang=js&"
export * from "./defaultPriceTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports